import { render, staticRenderFns } from "./AdminLog.vue?vue&type=template&id=a2ff8516&scoped=true&lang=pug&"
import script from "./AdminLog.vue?vue&type=script&lang=js&"
export * from "./AdminLog.vue?vue&type=script&lang=js&"
import style0 from "./AdminLog.vue?vue&type=style&index=0&id=a2ff8516&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ff8516",
  null
  
)

export default component.exports